import React, {useContext} from "react";
import {CustomerTypeContext, isCustomerCompany} from "../../context/customer-type-context";
import FormatUtils from "../../utils/FormatUtils";
import ConvertUtils from "../../utils/ConvertUtils";

import bodyTypeIcon from "../../assets/images/icons/bodytype.svg";
import engineIcon from "../../assets/images/icons/engine_capacity.svg";
import fuelTypeIcon from "../../assets/images/icons/fuel.svg";
import gearboxIcon from "../../assets/images/icons/gearbox.svg";
import {Icon, Intent} from "@blueprintjs/core";
import FavouriteVehicle from "../FavouriteVehicles/FavouriteVehicle";
import {IconNames} from "@blueprintjs/icons";
import DiscountPercentageRibbonFactory from "../../utils/DiscountPercentageRibbonFactory";
import {Link} from "react-router-dom";
import AppToaster from "../AppToaster";
import CalculationTypeLabel from "./CalculationTypeLabel";

function VehicleOfferListItem(props) {

    const customerContext = useContext(CustomerTypeContext);

    let title = props.offer.brandName + " " + props.offer.modelName;
    if (props.offer.versionName !== undefined) {
        title = props.offer.brandName + " " + props.offer.versionName;
    }

    let discountPercentageComponent = null;

    if (props.offer.specialOffer) {
        DiscountPercentageRibbonFactory.setOffer(props.offer);
        DiscountPercentageRibbonFactory.setIsCompany(isCustomerCompany(customerContext));

        if (props.showRibbons) {
            DiscountPercentageRibbonFactory.setStyleClassName("ribbon-hot-text-grid-view");
        } else {
            DiscountPercentageRibbonFactory.setStyleClassName("ribbon-hot-text-list-view");
        }

        discountPercentageComponent = DiscountPercentageRibbonFactory.create();
    } else if (props.offer.specialOfferText) {
        DiscountPercentageRibbonFactory.setOffer(props.offer);
        DiscountPercentageRibbonFactory.setIsCompany(isCustomerCompany(customerContext));
        if (props.showRibbons) {
            DiscountPercentageRibbonFactory.setStyleClassName("ribbon-hot-text-grid-view");
        } else {
            DiscountPercentageRibbonFactory.setStyleClassName("ribbon-hot-text-list-view");
        }

        discountPercentageComponent = DiscountPercentageRibbonFactory.createWithText(props.offer.specialOfferText);
    }

    let specialPriceBadge = null;
    if (props.offer.specialBannerEnabled) {
        const bannerClass = props.showRibbons ? "ribbon-hot-text-grid-view" : "ribbon-hot-text-list-view";
        specialPriceBadge = (
            <div
                className={bannerClass}
                style={{
                    color: props.offer.specialBannerFontColor || undefined,
                    backgroundColor: props.offer.specialBannerBackgroundColor || undefined
                }}
            >
                <p>{props.offer.specialBannerText || "Poznaj cenę specjalną"}</p>
            </div>
        );
    }

    let inStockLabel = null;
    let inStockLabelOnImage = null;
    if (props.offer.availability === "IN_STOCK" || props.offer.availability.includes("IN_STOCK")) {
        inStockLabel = (<div className="ribbon od-reki-label">Od ręki</div>);
        inStockLabelOnImage = (<span className="ribbon-od-reki-grid">Od ręki</span>);
    }

    let overlay = null;
    if (props.active === false) {
        overlay = <div onClick={() => props.onClick(props.offer, false)} className="offer-not-active"></div>;
    }

    const deleteSoldVehicleHandler = (event) => {
        event.preventDefault();

        let retrievedVehicles = localStorage.getItem('favouriteVehicles');
        let retrievedVehiclesToArray = JSON.parse(retrievedVehicles);

        retrievedVehiclesToArray = deleteAllVersionIds(retrievedVehiclesToArray, props.offer.vehicleIds);
        let afterEliminatedDuplicates = [...new Set(retrievedVehiclesToArray)];

        localStorage.setItem('favouriteVehicles', JSON.stringify(afterEliminatedDuplicates));

        AppToaster.show({message: 'Usunięto z ulubionych', intent: "warning", icon: "info-sign", timeout: 1500});

        props.refreshVehicles();
    };

    const deleteAllVersionIds = (vehiclesArray, vehicleIds) => {
        if (!vehicleIds) {
            return vehiclesArray;
        }

        if (!Array.isArray(vehicleIds)) {
            vehiclesArray = vehiclesArray.filter(existingId => existingId !== vehicleIds.toString());
        } else {
            vehicleIds.forEach(vehicleId => {
                vehiclesArray = vehiclesArray.filter(existingId => existingId !== vehicleId.toString());
            });
        }

        return vehiclesArray;
    };

    const displayDeleteButtonHandler = () => {
        if (props.deleteButton === true) {
            return (
                <div className="close-icon-sold-offer">
                    <Icon icon={IconNames.CROSS} iconSize={Icon.SIZE_LARGE} intent={Intent.PRIMARY} onClick={deleteSoldVehicleHandler}/>
                </div>
            );
        }
    };

    const isOfferCredit = () => {
        const condition = props.offer.condition;
        const salesDocument = props.offer.salesDocument;

        if ((condition === "USED" && salesDocument !== "FAKTURA_VAT") ||
            (condition === "USED" && salesDocument === "FAKTURA_VAT" && !isCustomerCompany(customerContext)) ||
            (condition === "DEMO" && salesDocument !== "FAKTURA_VAT") ||
            (condition === "DEMO" && salesDocument === "FAKTURA_VAT" && !isCustomerCompany(customerContext))) {
            return true;
        }

        return false;
    };

    const shouldShowNetto = () => {
        if (isOfferCredit()) {
            return false;
        }

        return isCustomerCompany(customerContext);
    };

    const formattedPrice = FormatUtils.formatMoney(shouldShowNetto() ? props.offer.installmentNet : props.offer.installmentGross);

    return (
        <Link to={{pathname: props.url}} className={[props.className, "offer"].filter(Boolean).join(" ")} style={{textDecoration: "none"}}>
            {overlay}
            {displayDeleteButtonHandler()}

            <div className="offer-fav-btn">
                <FavouriteVehicle
                    offer={props.offer}
                    refreshVehicles={() => props.refreshVehicles()}
                    deleteAllVersionIds={deleteAllVersionIds}
                />
            </div>

            {/* grid/slider: discount badge — between price and photo.
                Always rendered (even empty) so every tile reserves the same
                vertical space and cards stay aligned across a row. */}
            {props.showRibbons && (
                <div className="offer-badge-above">
                    {discountPercentageComponent}
                    {specialPriceBadge}
                </div>
            )}

            {/* photo — col 1 in list-view, top in grid-view */}
            <div className="offer-img">
                <div>
                    <img src={props.offer.imageUrl} alt={title}/>
                </div>
            </div>

            {/* grid/slider: availability/type badges — below photo, right-aligned */}
            {props.showRibbons && (
                <div className="offer-badge-below">
                    <CalculationTypeLabel calculationType={props.offer.calculationType} viewType="grid-view"/>
                    {inStockLabelOnImage}
                </div>
            )}

            {/* badges — below photo in list-view, hidden in grid-view */}
            <div className="offer-list-view">
                {!props.isSliderOffer && <CalculationTypeLabel calculationType={props.offer.calculationType} viewType="list-view"/>}
                {props.isSliderOffer ? null : inStockLabel}
            </div>

            {/* title + specs — col 2 in list-view */}
            <div className="offer-top">
                <span className="offer-title">{title}</span>
                <div className="offer-specs">
                    <div className="offer-specs-row">
                        <span className="offer-spec-item">
                            <img src={bodyTypeIcon} className="description-icon" alt="Nadwozie" title="Nadwozie"/>
                            {props.offer.manufactureYear}
                        </span>
                        <span className="offer-spec-item">
                            <img src={gearboxIcon} className="description-icon" alt="Skrzynia biegów" title="Skrzynia biegów"/>
                            {props.offer.gearboxType}
                        </span>
                    </div>
                    <div className="offer-specs-row">
                        <span className="offer-spec-item">
                            <img src={engineIcon} className="description-icon" alt="Silnik" title="Silnik"/>
                            {ConvertUtils.capacityFromCmToDm(props.offer.engineCapacity)} dm ({props.offer.enginePowerHP} KM)
                        </span>
                        <span className="offer-spec-item">
                            <img src={fuelTypeIcon} className="description-icon" alt="Paliwo" title="Paliwo"/>
                            {props.offer.fuelType}
                        </span>
                    </div>
                </div>
            </div>

            {/* price + CTA — col 3 in list-view, bottom in grid-view */}
            <div className="offer-bottom">
                {!props.showRibbons && !props.isSliderOffer && discountPercentageComponent}
                {!props.showRibbons && !props.isSliderOffer && specialPriceBadge}
                {!props.showRibbons && !props.isSliderOffer && (
                    <span className="offer-price-label">
                        Twoja rata {shouldShowNetto() ? 'netto' : 'brutto'} od
                    </span>
                )}
                <div className="offer-price-row">
                    <span className="offer-price-amount">{formattedPrice}</span>
                    <span className="offer-price-period">/ miesięcznie</span>
                </div>
                <button className="offer-check-btn">
                    <span>SPRAWDŹ</span>
                    <img src="/img/go.png" alt="GO" className="offer-check-btn-logo"/>
                </button>
            </div>
        </Link>
    );
}

export default VehicleOfferListItem;
